import { Button, Card, CarouselSection, Text } from '@/components';
import APP_CONFIG from '@/config/app';
import { CarouselScreenProps } from '@/interfaces';
import { logError } from '@/utils/logger';
import { ERROR_BOUNDARY } from '@/utils/strings';
import Image from 'next/image';
import { NextRouter, withRouter } from 'next/router';
import { Component, PropsWithChildren } from 'react';
interface ErrorBoundaryProps extends PropsWithChildren {
  router: NextRouter;
}
class ErrorBoundary extends Component<ErrorBoundaryProps> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  state: { hasError: boolean };
  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }
  componentDidCatch(error: any, errorInfo: any) {
    logError(error, 'ErrorBoundary.componentDidCatch', { errorInfo });
  }
  render() {
    if (this.state.hasError) {
      const slides: CarouselScreenProps[] = [
        {
          body: (
            <div className="flex flex-col h-full justify-center items-center gap-md text-center">
              <div className="flex items-center justify-center pb-12">
                <Image
                  src={APP_CONFIG.ERROR_BOUNDARY_ILLUSTRATION_URL}
                  alt="Peace Illustration"
                  className="object-contain"
                  layout="responsive"
                  width={100}
                  height={100}
                />
              </div>
              <div
                className="flex flex-col items-center mx-auto"
                style={{ maxWidth: '30rem' }}
              >
                <div className="flex flex-col items-center justify-center gap-sm w-full">
                  <Text
                    size="h3"
                    color="accent"
                    className="font-sans w-full text-left"
                  >
                    {ERROR_BOUNDARY.TITLE}
                  </Text>
                  <Text
                    color="secondary"
                    className="font-sans w-full text-left"
                  >
                    {ERROR_BOUNDARY.DECRIPTION}
                  </Text>
                </div>
                <div className="font-sans flex flex-row items-center justify-center pt-10 w-full">
                  <Button
                    intent={'primary'}
                    onClick={() => this.setState({ hasError: false })}
                  >
                    Refresh
                  </Button>
                </div>
              </div>
            </div>
          ),
        },
      ];
      return (
        <div className="grid place-items-center w-screen h-screen p-md">
          <Card className="w-full h-full p-md gap-md flex flex-col overflow-y-auto overflow-x-hidden scrollbar-hide">
            <div className="flex justify-center items-center w-full h-full">
              <CarouselSection
                screens={slides}
                showNavigationControlsInHeader={false}
                autoNavigate={false}
                className="w-full p-md"
                isBackgroundTransparent={true}
                isBorderTransparent={true}
              />
            </div>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
export default withRouter(ErrorBoundary);
